module.exports = __webpack_public_path__ + "static/media/hallway_scene_from_hell.8a748fae.png";